import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsOfService: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom align="center">
        利用規約
      </Typography>
      <Typography variant="subtitle1" align="center" gutterBottom>
        制定日：2025年4月17日
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>第1条（適用範囲）</Typography>
        <Typography paragraph>
          本規約は、本サービスの利用に関する一切の関係に適用されるものとし、
          利用者が本サービスを閲覧または利用した時点で適用されるものとします。
        </Typography>

        <Typography variant="h6" gutterBottom>第2条（提供内容）</Typography>
        <Typography paragraph>
          本サービスでは、以下のコンテンツ等を提供します。
          IT基礎、インフラ基礎（Linuxコマンド、SQL文、Bashスクリプト、バッチファイル作成）、
          ベアメタル型仮想基盤構築方法、ミドルウェア（Webサーバー、DBサーバー）構築手順、
          AWS各種サービスの構築手順、AWS認定SAA試験向け問題集、理解度チェック問題集、構築に関する動画コンテンツ、
          Excel VBA、Access VBA、Java、JavaScript（モダン）、React、TypeScript に関するプログラミングカリキュラム。
          なお、上記のうち特定のコンテンツは、当社が許可したメールアドレス及びパスワードを登録した利用者のみが閲覧・利用できるものとします。
        </Typography>

        <Typography variant="h6" gutterBottom>第3条（ユーザー登録）</Typography>
        <Typography paragraph>
          利用者は、所定の方法によりメールアドレス及びパスワードを登録し、ゲストユーザーとして本サービスを利用することができます。
          ゲストユーザーは、本サービスにおける一部コンテンツのみ利用することができるものとします。
          登録情報に虚偽、誤記または漏洩があった場合、当社は登録の取消し又は利用制限を行うことがあります。
        </Typography>

        <Typography variant="h6" gutterBottom>第4条（禁止事項）</Typography>
        <Typography paragraph>
          利用者は、本サービスの利用にあたり、以下の行為を行ってはなりません。
          本サービスに掲載されている資料、問題集、動画等の無断転載、転用、複製。
          不正アクセス行為又はこれを試みる行為。
          当社又は第三者の著作権その他知的財産権を侵害する行為。
          他人になりすます行為。
          営利目的での本サービス内容の二次利用。
          当社の許可なく、本サービスの情報をSNS、ウェブサイト等に掲載、共有、又は保存する行為
          （スクリーンキャプチャ、動画撮影、ダウンロード行為等を含みます）。
        </Typography>

        <Typography variant="h6" gutterBottom>第5条（サービスの変更・中断・終了）</Typography>
        <Typography paragraph>
          当社は、利用者への事前通知なくして、本サービスの内容を変更、中断又は終了することがあります。
          当社は、サービスの変更、中断又は終了により、利用者または第三者が被った不利益または損害について一切の責任を負いません。
        </Typography>

        <Typography variant="h6" gutterBottom>第6条（免責事項）</Typography>
        <Typography paragraph>
          当社は、本サービスの利用による学習効果又は結果について一切保証するものではありません。
          本サービスの利用に起因して利用者に生じたあらゆる損害について、当社は一切責任を負わないものとします。
        </Typography>

        <Typography variant="h6" gutterBottom>第7条（知的財産権）</Typography>
        <Typography paragraph>
          本サービスに含まれるすべてのコンテンツ（文章、画像、動画、資料、プログラム、担当者写真等）の著作権その他の知的財産権は、
          当社又は正当な権利を有する第三者に帰属します。
          利用者は、当社及び権利者の許可なく、これらを複製、転載、頒布、改変、公開、送信又はその他の利用をしてはならないものとします。
        </Typography>

        <Typography variant="h6" gutterBottom>第8条（利用規約の変更）</Typography>
        <Typography paragraph>
          当社は、必要に応じて本規約を変更することができるものとします。
          変更後の規約は、当社ウェブサイト上に掲載された時点で効力を生じるものとします。
        </Typography>

        <Typography variant="h6" gutterBottom>第9条（準拠法・管轄裁判所）</Typography>
        <Typography paragraph>
          本規約の解釈及び適用は日本法に準拠し、本サービスに関連して生じた一切の紛争については、
          東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
